
import { Vue } from 'vue-class-component';

export default class MaterialTopAppBarAdjust extends Vue {}
